var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M27.4688 5.46647V8.39981C27.4688 9.46647 26.8021 10.7998 26.1354 11.4665L20.4021 16.5331C19.6021 17.1998 19.0688 18.5331 19.0688 19.5998V25.3331C19.0688 26.1331 18.5354 27.1998 17.8687 27.5998L16.0021 28.7998C14.2688 29.8665 11.8687 28.6665 11.8687 26.5331V19.4665C11.8687 18.5331 11.3354 17.3331 10.8021 16.6665L9.46875 15.2665L17.2288 2.7998H24.8021C26.2688 2.7998 27.4688 3.9998 27.4688 5.46647Z",
    fill: "#2D5FA1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0646 2.7998L8.15792 13.8798L5.73125 11.3331C5.06458 10.6665 4.53125 9.46647 4.53125 8.66647V5.5998C4.53125 3.9998 5.73125 2.7998 7.19792 2.7998H15.0646Z",
    fill: "#2D5FA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.ff3ace1c565fa987b7d84f7b6b8835dd.svg";
export { ForwardRef as ReactComponent };